import React from "react";

const FAQAccordion = ({ faqs = [] }) => {
  if (!faqs.length) {
    return <p className="things-muted-text">No FAQs available yet.</p>;
  }

  return (
    <div className="accordion" id="thingsFaqAccordion">
      {faqs.map((faq, index) => (
        <div className="accordion-item" key={faq.question}>
          <h2 className="accordion-header" id={`faq-heading-${index}`}>
            <button
              className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#faq-collapse-${index}`}
              aria-expanded={index === 0}
              aria-controls={`faq-collapse-${index}`}
            >
              {faq.question}
            </button>
          </h2>
          <div
            id={`faq-collapse-${index}`}
            className={`accordion-collapse collapse ${
              index === 0 ? "show" : ""
            }`}
            aria-labelledby={`faq-heading-${index}`}
            data-bs-parent="#thingsFaqAccordion"
          >
            <div className="accordion-body">
              <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQAccordion;
